import { render, staticRenderFns } from "./studyinfo.vue?vue&type=template&id=168374aa&scoped=true&"
import script from "./studyinfo.vue?vue&type=script&lang=js&"
export * from "./studyinfo.vue?vue&type=script&lang=js&"
import style0 from "./studyinfo.vue?vue&type=style&index=0&id=168374aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168374aa",
  null
  
)

export default component.exports